export const PlayerTrackingColumnName = {
  FirstBase: 'firstBase',
  SecondBase: 'secondBase',
  ThirdBase: 'thirdBase',
  FirstBaseman: 'firstBaseman',
  SecondBaseman: 'secondBaseman',
  ThirdBaseman: 'thirdBaseman',
  ShortStopper: 'shortStopper',
  LeftFielder: 'leftFielder',
  CenterFielder: 'centerFielder',
  RightFielder: 'rightFielder',
};
